import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useIdempotentAppMutation } from '../use-idempotent-app-mutation.hook';

export const useDelete = () => {
  const { mutate: deletePool, isPending } = useIdempotentAppMutation([QueryKey.DELETE_POOL], {
    mutationFn: ({ companyId, poolId }: { companyId: string; poolId: string }, { headers }) =>
      ApiService.delete(
        {
          endpoint: BackendRoute.COMPANIES,
          routePath: [companyId, 'pools', poolId],
        },
        { headers },
      ),
  });
  return { deletePool, isPending };
};
